import React from "react";
import UploadForm from "../components/UploadForm";

const InvoiceUpload = (props) => {
  return <UploadForm {...props} type="invoice" />;
}

export default InvoiceUpload;



// WEBPACK FOOTER //
// ./src/features/trade_documents/containers/InvoiceUpload.js